import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global, BaoCao } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';

import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');


@Component({
    selector: 'app-dieuhanh-chitietphaithuphaitraedit',
  templateUrl: './chitietphaithuphaitraedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./chitietphaithuphaitraedit.component.scss'],
    providers: [ListService, Repository]
})


export class chitietphaithuphaitraeditComponent implements OnInit {

  
 

  tong_hv: number = 0;
  tong_dihoc: number = 0;
  tong_nghihoc: number = 0;

  doituongSelect: any = {
    Id: null, DonViId: null, LopId: null, NgayHoc: null
    , DayChinhId: null, TroGiang1Id: null, DoTuoi: null, GhiChu: null
    , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
    , ChiTiets: [], TenLop: null
  };       
  
  inputGiangViens: any;
  
 
  dslops: any;
  dschinhanhs: any;
  doituongkethua: any;
  doanhnghiepid: string = null;
  @Output() save: EventEmitter<any> = new EventEmitter();
  datas: any;
  data2s: any;
  data: any;
  public dulieu: any = { dataGrid: null, dataGridTimKiem: null, datatieude: null, sobanghi: null };
  indLoading: boolean = false;
  dataFrm: FormGroup;
  modalTitle: string;
  modalBtnTitle: string;
  Id: string;
  NgayHienTai: Date = new Date();
  inputDonVi: any;
  public DonViDropId: any = { Id: null, Ten: null };
  public TaiKhoanDropId: any = { Id: null, Ten: null };
  TaiKhoanId: any;
  selecteddonvis: any;
  selectedchuongs: any;
  selectedkhoans: any;
  Ma_Tai_Khoan: any;
  dropdownList_DonVi = [];
  inputTaiKhoan: any;
  dropdownList_TaiKhoan = [];
  selectedItems = [];
  dropdownSettings = {};
  khoangthoigian: number = 0;
  tabselected: number = 1;
  inputthangs: any = [
    { text: "Hôm nay", value: 0 },
    { text: "Tháng 1", value: 1 },
    { text: "Tháng 2", value: 2 },
    { text: "Tháng 3", value: 3 },
    { text: "Tháng 4", value: 4 },
    { text: "Tháng 5", value: 5 },
    { text: "Tháng 6", value: 6 },
    { text: "Tháng 7", value: 7 },
    { text: "Tháng 8", value: 8 },
    { text: "Tháng 9", value: 9 },
    { text: "Tháng 10", value: 10 },
    { text: "Tháng 11", value: 11 },
    { text: "Tháng 12", value: 12 },
    { text: "Quý I", value: 13 },
    { text: "Quý II", value: 14 },
    { text: "Quý III", value: 15 },
    { text: "Quý IV", value: 16 },
    { text: "Tuần này", value: 17 },
    { text: "Tháng này", value: 18 },
    { text: "Năm nay", value: 19 },
    { text: "Đầu năm đến nay", value: 20 },
    { text: "Năm trước", value: 21 },

  ];
  dstrangthais: any = [
    { Ten: 'Nghỉ học', Id: 0 },
    { Ten: 'Học bình thường', Id: 1 },
    { Ten: 'Bảo lưu', Id: 2 },
    { Ten: 'Chưa thuộc lớp nào', Id: 3 }

  ];
  public thangs: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },
    { text: "5", value: 5 },
    { text: "6", value: 6 },
    { text: "7", value: 7 },
    { text: "8", value: 8 },
    { text: "9", value: 9 },
    { text: "10", value: 10 },
    { text: "11", value: 11 },
    { text: "12", value: 12 }
  ];

  public quys: Array<{ text: string, value: number }> = [
    { text: "1", value: 1 },
    { text: "2", value: 2 },
    { text: "3", value: 3 },
    { text: "4", value: 4 },

  ];

  public nams: Array<{ text: string, value: number }> = [
    { text: (this.NgayHienTai.getFullYear() - 3).toString(), value: (this.NgayHienTai.getFullYear() - 3) },
    { text: (this.NgayHienTai.getFullYear() - 2).toString(), value: (this.NgayHienTai.getFullYear() - 2) },
    { text: (this.NgayHienTai.getFullYear() - 1).toString(), value: (this.NgayHienTai.getFullYear() - 1) },
    { text: this.NgayHienTai.getFullYear().toString(), value: this.NgayHienTai.getFullYear() },
    { text: (this.NgayHienTai.getFullYear() + 1).toString(), value: (this.NgayHienTai.getFullYear() + 1) },
    { text: (this.NgayHienTai.getFullYear() + 2).toString(), value: (this.NgayHienTai.getFullYear() + 2) },
    { text: (this.NgayHienTai.getFullYear() + 3).toString(), value: (this.NgayHienTai.getFullYear() + 3) },

  ];
  tong_tien: number = 0;
  tong_giaphi: number = 0;
  tong_giamgia: number = 0;
  tong_thucthu: number = 0;
  tong_sobuoi: number = 0;
  public chons: Array<{ text: string, value: number }> = [
    { text: "Theo ngày", value: 1 },
    { text: "Theo tháng", value: 2 },
    { text: "Theo quý", value: 3 },
    { text: "Theo năm", value: 4 },

  ];
  chongioitinhs: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Nữ" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Nam" }];
  TatCa: boolean = false;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public TimKiem: string;
  public StartPage: number = 1;
  public EndPage: number = 100;
  public pageSize: number = 100;
  public pages: any;
  public totalPages: number;
  public TimKiems: any = {
    Don_Vi_Id: null
    , NhanSuId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , BaoCaoId: null
  };
  public ngaytimkiem: Date = new Date();
  TichTatCa() {
    this.datas.forEach((item: any) => {
      item.Tich = !this.TatCa;
    });
  }
  onKeydownEvent(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search();
    }
  }
  pageChanged(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage = event.page;
    this.Loaddatas();
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas();
  }
  public onBlur(): void {
    this.Loaddatas();
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 50;
    this.Loaddatas();
  }
  search1() {
    this.Loaddatas();
  }
  Loaddatas(): void {

    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiems.Don_Vi_Id = this.donviid;
    this.TimKiems.UserName = this.currentUser.user_name;
    this.TimKiems.LopId = this.lopid;
    this.TimKiems.Nam = this.currentUser.nam_ke_toan;
    this.TimKiems.startPage = this.StartPage;
    this.TimKiems.endPage = this.EndPage;
    if (this.ngaytimkiem != null) {
      this.TimKiems.ModifiedS = this.ngaytimkiem.getFullYear() + '-' + (this.ngaytimkiem.getMonth() + 1) + '-' + this.ngaytimkiem.getDate();
    }
    else
      this.TimKiems.ModifiedS = null;


    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiems)
    };
    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/get_dangky_phaitra_listviewpage/", this.TimKiems)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {

          
          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);

          let start, end;

          if (this.totalPages <= 5) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 4;
              end = this.totalPages;
            } else {
              start = this.currentPage - 2;
              end = this.currentPage + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;

        this.tong_giaphi = 0;
        this.tong_giamgia = 0;
        this.tong_thucthu = 0;
        this.tong_sobuoi = 0;
        // tính tổng
        if (this.datas != null)
          this.datas.forEach(
            (item) => {
              this.tong_giaphi = this.tong_giaphi + (item.GiaPhi === null ? 0 : item.GiaPhi);
              this.tong_giamgia = this.tong_giamgia + (item.DuocGiam === null ? 0 : item.DuocGiam);
              this.tong_thucthu = this.tong_thucthu + (item.ThucThu === null ? 0 : item.ThucThu);
              this.tong_sobuoi = this.tong_sobuoi + (item.SoBuoi === null ? 0 : item.SoBuoi);
            }
          );

        (window as any).timer4(0, 1500);

      });



  }


  public TuNgay: Date = new Date();
  public DenNgay: Date = new Date();
  public TuNgay1: Date = new Date();
  public DenNgay1: Date = new Date();
  public tTuNgay: string;
  public tDenNgay: string;

  
  public totalItem2s: number = 0;
  public currentPage2: number = 1;
  public maxSize2: number = 5;
  public TimKiem2: string;
  public StartPage2: number = 1;
  public EndPage2: number = 100;
  public pageSize2: number = 100;
  public page2s: any;
  public totalPage2s: number;
  public TimKiem2s: any = {
    Don_Vi_Id: null
    , NhanSuId: null
    , DangKyId: null
    , UserName: null
    , Nam: null
    , TuNgay: null
    , DenNgay: null
    , Phan_He_Id: null
    , TimKiem: null
    , Loai: null
    , startPage: null
    , endPage: null
    , Ngay: null
    , NgayS: null
    , Ma: null
    , Ten: null
    , Cha: null
    , GhiChu: null
    , NhomDoiTuong: null
    , SapXep: null
    , Modified: null
    , ModifiedS: null
    , ModifiedBy: null
    , BaoCaoId: null
  };
  onKeydownEvent2(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.search2();
    }
  }

  pageChanged2(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage2 = event.page;
    this.Loaddata2s();
  }
  setPage2(page: number): void {
    if (page < 1 || page > this.totalPage2s) {
      return;
    }

    this.currentPage2 = page;
    this.Loaddata2s();
  }
  public onBlur2(): void {
    this.Loaddata2s();
  }
  search2() {
    this.currentPage2 = 1;
    this.pageSize2 = 50;
    this.Loaddata2s();
  }
  search21() {
    this.Loaddata2s();
  }
  Loaddata2s(): void {
    this.data2s = [];
    this.StartPage2 = (this.currentPage2 - 1) * this.pageSize2 + 1;
    this.EndPage2 = this.currentPage2 * this.pageSize2;
    this.totalItem2s = 0;
    this.TimKiem2s.Don_Vi_Id = this.donviid;
    this.TimKiem2s.UserName = this.currentUser.user_name;
    this.TimKiem2s.LopId = this.lopid;
    this.TimKiem2s.Nam = this.currentUser.nam_ke_toan;
    this.TimKiem2s.startPage = this.StartPage2;
    this.TimKiem2s.endPage = this.EndPage2;

    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiem2s)
    };
    $('#loading').show();
    this.repo.postRequest("api/dangkygoihoc/get_datra_listviewpage/", this.TimKiem2s)
      .subscribe(response => {
        $('#loading').hide();
        this.totalPage2s = 0;
        this.totalItem2s = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItem2s = item["totalRows"];
          this.totalPage2s = Math.ceil(this.totalItem2s / this.pageSize2);

          let start, end;

          if (this.totalPage2s <= 5) {
            start = 1;
            end = this.totalPage2s;
          } else {
            if (this.currentPage2 <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage2 + 1 >= this.totalPage2s) {
              start = this.totalPage2s - 4;
              end = this.totalPage2s;
            } else {
              start = this.currentPage2 - 2;
              end = this.currentPage2 + 2;
            }
          }

          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.page2s = resultArray;
        }
        this.data2s = response;

        this.tong_tien = 0;
        // tính tổng
        if (this.data2s != null)
          this.data2s.forEach(
            (item) => {
              this.tong_tien = this.tong_tien + (item.SoTien === null ? 0 : item.SoTien);

            }
          );

        (window as any).timer5(0, 1500);

      });



  }

 

 
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = {
    prefix: '',
    thousands: ',',
    decimal: '.',
    precision: 0,
    allowNegative: true
  };

  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  phanheid: any;
  lopid: string;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private fb: FormBuilder, private _dataService: ListService, public repo: Repository) {



  }
  save_chondoituong() {
    let tdoituong = [];
    this.save.emit(tdoituong);
  }
  // @HostListener('document:keydown', ['$event'])
  public innerHeight: any
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;

  loadDataInit(pheid: string, row: any, donviid: string, tungay: Date, denngay: Date) {
    this.TimKiems.NhanSuId = row.NhanSuId;
    this.TimKiem2s.NhanSuId = row.NhanSuId;
    this.TimKiems.TuNgay = tungay;
    this.TimKiems.DenNgay = denngay;
    this.TimKiem2s.TuNgay = tungay;
    this.TimKiem2s.DenNgay = denngay;
    //this.lopid = row.LopId;
    this.datas = [];
    this.data2s = [];
    this.ngaytimkiem = null;
    this.StartPage = 1;
    this.EndPage = 20;
    this.ngaytimkiem = null;
    this.innerHeight = window.innerHeight - 250;
    this.phanheid = pheid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = this.currentUser.id_don_vi;
      this.TimKiems.DonViId = this.donviid;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
      var giatri = this.currentUser.ds_quyen.filter(name => name.Id === this.phanheid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].Them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].Sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].Xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
       
      }
     
      
    }


    this.doituongSelect = {
      Id: null, DonViId: null, LopId: null, NgayHoc: null
      , DayChinhId: null, TroGiang1Id: null, DoTuoi: null, GhiChu: null
      , Created: null, Modified: null, CreatedBy: null, ModifiedBy: null
      , ChiTiets: [], TenLop: null
    };

    if (donviid != null)
      this.doituongSelect.DonViId = parseInt(donviid);
    else
      this.doituongSelect.DonViId = parseInt(this.currentUser.id_don_vi);


    this.Loaddatas();
    this.Loaddata2s();
        
    
  }

  
    
  public ngonngu(text: string) {
    return this.repo.NgonNgu(text);
  }
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }
    this.LoadCategory();
  }

  LoadCategory(): void {

  }
  //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  maxcot: number = 13;

  

  comboSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
  rowSelected: any = null;
  comboSeleted: NgSelectComponent;

 
  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }
   
  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }

 
 

}
